import { rem } from 'polished';

import IconStepper, { IconStepperProps } from '@vfuk/core-icon-stepper';
import BackButton from './BackButton/BackButton';
import NextButton from './NextButton/NextButton';

import {
  ButtonsWrapper,
  CancelButton,
  HeadingSubtitleProps,
  HeadingText,
  HeadingTitleProps,
  HeadingWrapper,
  NavigationWrapper,
  NextButtonWrapper,
  StepWrapper,
  StepperBox,
  StepperWrapper,
} from './ConfigureSteps.styles';

interface ConfigureStepsProps {
  title: string;
  countStep: number;
  currentStep: number;
  disableSteps?: boolean;
  steps: IconStepperProps['steps'];
  buttonDestinationLink: string;
  handleBackClickButton: () => void;
  handleNextClickButton: () => void;
}

const ConfigureSteps = ({
  title,
  disableSteps,
  steps,
  countStep,
  currentStep,
  buttonDestinationLink,
  handleBackClickButton,
  handleNextClickButton,
}: ConfigureStepsProps) => (
  <StepWrapper>
    <HeadingWrapper textAlign="center">
      <HeadingText as="h2" {...HeadingTitleProps}>
        Configure the Bundle
      </HeadingText>

      <HeadingText as="h3" {...HeadingSubtitleProps}>
        {title}
      </HeadingText>
    </HeadingWrapper>

    <NavigationWrapper
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      mt={disableSteps ? { base: 8, md: `${rem('-84px')}` } : { md: rem('50px'), lg: 12 }}
    >
      <ButtonsWrapper display={{ base: 'none', md: 'flex' }}>
        <CancelButton>
          <BackButton step={countStep} buttonLink={buttonDestinationLink} handleButtonClick={handleBackClickButton} />
        </CancelButton>
      </ButtonsWrapper>

      {!disableSteps && (
        <StepperWrapper stepsLength={steps.length}>
          <StepperBox w={'full'} mt={{ base: rem('42px'), md: 0 }} mb={{ base: rem('46px'), md: 0 }}>
            {steps.length > 0 && <IconStepper currentStep={currentStep} steps={steps} hideControls />}
          </StepperBox>
        </StepperWrapper>
      )}

      {!disableSteps ? (
        <ButtonsWrapper direction="row" justify="space-between">
          <CancelButton display={{ md: 'none' }} width={{ md: '50%' }}>
            <BackButton step={countStep} buttonLink={buttonDestinationLink} handleButtonClick={handleBackClickButton} />
          </CancelButton>
          <NextButtonWrapper
            sx={{
              ...(countStep === steps.length - 1 && {
                a: {
                  p: 0,
                  span: {
                    display: 'none',
                  },
                },
              }),
            }}
          >
            <NextButton step={countStep} steps={steps} handleClickButton={handleNextClickButton} />
          </NextButtonWrapper>
        </ButtonsWrapper>
      ) : (
        <ButtonsWrapper direction="row" justify="space-between" display={{ base: 'flex', md: 'none' }}>
          <CancelButton width={{ md: '50%' }}>
            <BackButton
              step={countStep}
              disableSteps={disableSteps}
              buttonLink={buttonDestinationLink}
              handleButtonClick={handleBackClickButton}
            />
          </CancelButton>
          <NextButtonWrapper
            sx={{
              button: {
                p: 0,
                span: {
                  display: 'none',
                },
              },
            }}
          >
            <NextButton
              step={countStep}
              steps={steps}
              handleClickButton={handleNextClickButton}
              disableSteps={disableSteps}
            />
          </NextButtonWrapper>
        </ButtonsWrapper>
      )}
    </NavigationWrapper>
  </StepWrapper>
);

export default ConfigureSteps;
